import React, { useState, useEffect, Fragment } from 'react';
import { translate } from '../../../Services/translation';
import { post } from '../../../Services/http';
import SimplePopup from '../../SimplePopUp';

const MyDetailsUpdateCard = (props) => {
    const [showPopup, setShowPopup] = useState(false);

    const handleButtonClick = () => {
        setShowPopup(true);
      };
      const handleClosePopup = () => {
        setShowPopup(false);
      };      

    const AddDummyProductToCart = async () => {
        post('api/cart/adddummyproduct').then(() => handleButtonClick());
      }

    return (
    <>
    <div class="row mydetails-panel__update-card">
        <div class="columns small-6">
            <h4>{translate("coptikk.adminportal.subscription.paymentmethodtext")}</h4>
            <div>{translate("coptikk.mypage.selectedpaymentmethod")}{translate("coptikk.mypage.selectedpaymentmethod.name")}</div>
        </div>
        <div class="columns small-6 mydetails-panel__update-card--wrapper">
            <div class='mypage-subscription__update-card--wrapper'>
                <div class='mypage-subscription__update-card--header'>{translate("coptikk.mypage.updatecard.header")}</div>
                <div class='mypage-subscription__update-card--description'>{translate("coptikk.mypage.updatecard.descriptiontext")}</div>
                <div class='mypage-subscription__update-card--description' dangerouslySetInnerHTML={{ __html: translate("coptikk.mypage.updatecard.description.steps") }}></div>
                <button class='button secondary mypage-subscription__update-card--button-details' onClick={() => AddDummyProductToCart()}>{translate("coptikk.mypage.updatecard.buttontext")}</button>
            </div>
        </div>    
    </div>
    {showPopup && (
        <SimplePopup onClose={handleClosePopup} checkoutUrl={props.checkoutUrl} />
      )}
    </>)

}

export default MyDetailsUpdateCard;